/**
 * GENERATED by scripts/build-historical-scenario-data.mjs — do not edit by hand.
 *
 * Research extract "2026-09-17.1" (retrieved 2026-09-17), status
 * "research; not live preset approval". Units: percent except explicitly named levels and percentage-point spreads. Percentages are percentage units
 * (−29.9 means −29.9%), at the research file's source precision. `value: null`
 * means no observation exists in the extract — it is never zero.
 *
 * ONLY FIGURES FROM CLEARED SOURCES ARE SHIPPED. This module is bundled into the
 * public web app, so a figure whose source is not cleared for commercial use
 * (`HISTORICAL_SOURCE_PERMISSIONS`) is written as `withheld_unlicensed` with a
 * null value. The complete research extract stays in docs/research/ and is read
 * only by tests, through `historicalDataFromResearch()`.
 */
export const HISTORICAL_RESEARCH_VERSION = '2026-09-17.1';
export const HISTORICAL_RESEARCH_RETRIEVED_AT = '2026-09-17';
export const UK_ANNUAL_RECORDS = [
    {
        year: 1929,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: null,
            source: 'S10',
            quality: 'missing',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1930,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: null,
            source: 'S10',
            quality: 'missing',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1931,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: null,
            source: 'S10',
            quality: 'missing',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1932,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: null,
            source: 'S10',
            quality: 'missing',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1933,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: null,
            source: 'S10',
            quality: 'missing',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1934,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: null,
            source: 'S10',
            quality: 'missing',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1973,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 9.2,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1974,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 16,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1975,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 24.2,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1976,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 16.5,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1977,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 15.8,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1978,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 8.3,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1979,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 13.4,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1980,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 18,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1981,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 11.9,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1982,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 8.6,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1983,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 4.6,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1987,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 4.2,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1988,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        rpi_pct: {
            value: 4.9,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1989,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 5.2,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 7.8,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1990,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 7,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 9.5,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1991,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 7.5,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 5.9,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1992,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 4.2,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3.7,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1993,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 2.5,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 1.6,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1994,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 2,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 2.4,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1995,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 2.6,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3.5,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1996,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 2.4,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 2.4,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1997,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 1.8,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3.1,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1998,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 1.6,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3.4,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 1999,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 1.3,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 1.5,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2000,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 0.8,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2001,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 1.2,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 1.8,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 5.111821086261981,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2002,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 1.3,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 1.7,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 3.039513677811545,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2003,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 1.4,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 2.9,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 3.2448377581120846,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2004,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 1.3,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 4.285714285714293,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2005,
        equity_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: null,
            source: 'S01',
            quality: 'withheld_unlicensed',
        },
        cpi_pct: {
            value: 2.1,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 2.8,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 4.657534246575334,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'JST annual capital gain; source-specific timing',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2008,
        equity_tr_pct: {
            value: null,
            source: 'S04',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S06',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: -14.9,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 3.6,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 4,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 3.3333333333333437,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2009,
        equity_tr_pct: {
            value: null,
            source: 'S04',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S06',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 4.4,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 2.2,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: -0.5,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 0,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2010,
        equity_tr_pct: {
            value: null,
            source: 'S04',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S06',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 0.4,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 3.3,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 4.6,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 2.304147465437789,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'missing',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2011,
        equity_tr_pct: {
            value: null,
            source: 'S04',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S06',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: -1,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 4.5,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 5.2,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 2.4774774774774855,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2012,
        equity_tr_pct: {
            value: null,
            source: 'S04',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S06',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 1.1,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 2.8,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3.2,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 1.318681318681314,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2013,
        equity_tr_pct: {
            value: null,
            source: 'S04',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S06',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 5.4,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 2.6,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 1.0845986984815648,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2016,
        equity_tr_pct: {
            value: null,
            source: 'S05',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S07',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 5.2,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 0.7,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 1.8,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 2.4896265560165887,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_rate_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        mortgage_2y75_pct: {
            value: null,
            source: 'S14',
            quality: 'missing',
        },
        bank_avg_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        bank_end_pct: {
            value: null,
            source: 'S02',
            quality: 'withheld_unlicensed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average effective mortgage rate (A31 L)',
    },
    {
        year: 2017,
        equity_tr_pct: {
            value: null,
            source: 'S05',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S07',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 4.6,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 2.7,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3.6,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 2.2267206477732726,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: 0.1475,
            source: 'S12',
            quality: 'derived_monthly_mean',
        },
        mortgage_rate_pct: {
            value: 4.376666666666667,
            source: 'S13',
            quality: 'derived_monthly_mean',
        },
        mortgage_2y75_pct: {
            value: 1.4608333333333334,
            source: 'S14',
            quality: 'derived_monthly_mean',
        },
        bank_avg_pct: {
            value: 0.2910958904109589,
            source: 'S11',
            quality: 'derived_daily_time_weighted',
        },
        bank_end_pct: {
            value: 0.5,
            source: 'S11',
            quality: 'observed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average quoted revert-to rate; NOT effective stock rate',
    },
    {
        year: 2018,
        equity_tr_pct: {
            value: null,
            source: 'S05',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S07',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 2,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 2.5,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3.3,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 2.970297029702973,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: 0.2275,
            source: 'S12',
            quality: 'derived_monthly_mean',
        },
        mortgage_rate_pct: {
            value: 4.255833333333333,
            source: 'S13',
            quality: 'derived_monthly_mean',
        },
        mortgage_2y75_pct: {
            value: 1.6875,
            source: 'S14',
            quality: 'derived_monthly_mean',
        },
        bank_avg_pct: {
            value: 0.6041095890410959,
            source: 'S11',
            quality: 'derived_daily_time_weighted',
        },
        bank_end_pct: {
            value: 0.75,
            source: 'S11',
            quality: 'observed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average quoted revert-to rate; NOT effective stock rate',
    },
    {
        year: 2019,
        equity_tr_pct: {
            value: null,
            source: 'S05',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S07',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 0.9,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 1.8,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 2.6,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 3.4615384615384714,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: 0.42333333333333334,
            source: 'S12',
            quality: 'derived_monthly_mean',
        },
        mortgage_rate_pct: {
            value: 4.305833333333333,
            source: 'S13',
            quality: 'derived_monthly_mean',
        },
        mortgage_2y75_pct: {
            value: 1.5933333333333335,
            source: 'S14',
            quality: 'derived_monthly_mean',
        },
        bank_avg_pct: {
            value: 0.75,
            source: 'S11',
            quality: 'derived_daily_time_weighted',
        },
        bank_end_pct: {
            value: 0.75,
            source: 'S11',
            quality: 'observed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average quoted revert-to rate; NOT effective stock rate',
    },
    {
        year: 2020,
        equity_tr_pct: {
            value: null,
            source: 'S05',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S07',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 7,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 0.9,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 1.5,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 1.6728624535315983,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: 0.19333333333333333,
            source: 'S12',
            quality: 'derived_monthly_mean',
        },
        mortgage_rate_pct: {
            value: 3.785833333333333,
            source: 'S13',
            quality: 'derived_monthly_mean',
        },
        mortgage_2y75_pct: {
            value: 1.5783333333333331,
            source: 'S14',
            quality: 'derived_monthly_mean',
        },
        bank_avg_pct: {
            value: 0.22759562841530054,
            source: 'S11',
            quality: 'derived_daily_time_weighted',
        },
        bank_end_pct: {
            value: 0.1,
            source: 'S11',
            quality: 'observed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average quoted revert-to rate; NOT effective stock rate',
    },
    {
        year: 2021,
        equity_tr_pct: {
            value: null,
            source: 'S05',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S07',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 7.3,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 2.6,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 4.1,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 6.032906764168189,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: 0.0825,
            source: 'S12',
            quality: 'derived_monthly_mean',
        },
        mortgage_rate_pct: {
            value: 3.61,
            source: 'S13',
            quality: 'derived_monthly_mean',
        },
        mortgage_2y75_pct: {
            value: 1.4483333333333333,
            source: 'S14',
            quality: 'derived_monthly_mean',
        },
        bank_avg_pct: {
            value: 0.10657534246575343,
            source: 'S11',
            quality: 'derived_daily_time_weighted',
        },
        bank_end_pct: {
            value: 0.25,
            source: 'S11',
            quality: 'observed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average quoted revert-to rate; NOT effective stock rate',
    },
    {
        year: 2022,
        equity_tr_pct: {
            value: null,
            source: 'S05',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S07',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 7.3,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 9.1,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 11.6,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 6.206896551724128,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: 0.48416666666666663,
            source: 'S12',
            quality: 'derived_monthly_mean',
        },
        mortgage_rate_pct: {
            value: 4.708333333333333,
            source: 'S13',
            quality: 'derived_monthly_mean',
        },
        mortgage_2y75_pct: {
            value: 3.5050000000000003,
            source: 'S14',
            quality: 'derived_monthly_mean',
        },
        bank_avg_pct: {
            value: 1.4657534246575343,
            source: 'S11',
            quality: 'derived_daily_time_weighted',
        },
        bank_end_pct: {
            value: 3.5,
            source: 'S11',
            quality: 'observed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average quoted revert-to rate; NOT effective stock rate',
    },
    {
        year: 2023,
        equity_tr_pct: {
            value: null,
            source: 'S05',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S07',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: -2.7,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 7.3,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 9.7,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 6.980519480519476,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: 2.1091666666666664,
            source: 'S12',
            quality: 'derived_monthly_mean',
        },
        mortgage_rate_pct: {
            value: 7.53,
            source: 'S13',
            quality: 'derived_monthly_mean',
        },
        mortgage_2y75_pct: {
            value: 5.308333333333334,
            source: 'S14',
            quality: 'derived_monthly_mean',
        },
        bank_avg_pct: {
            value: 4.67945205479452,
            source: 'S11',
            quality: 'derived_daily_time_weighted',
        },
        bank_end_pct: {
            value: 5.25,
            source: 'S11',
            quality: 'observed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average quoted revert-to rate; NOT effective stock rate',
    },
    {
        year: 2024,
        equity_tr_pct: {
            value: null,
            source: 'S05',
            quality: 'withheld_unlicensed',
        },
        gilt_tr_pct: {
            value: null,
            source: 'S07',
            quality: 'withheld_unlicensed',
        },
        house_price_pct: {
            value: 3.1,
            source: 'S08',
            quality: 'observed',
        },
        cpi_pct: {
            value: 2.5,
            source: 'S09',
            quality: 'observed',
        },
        rpi_pct: {
            value: 3.6,
            source: 'S10',
            quality: 'observed',
        },
        wage_growth_pct: {
            value: 5.31107738998482,
            source: 'S16',
            quality: 'derived_annual_average_levels',
        },
        deposit_rate_pct: {
            value: 2.7358333333333333,
            source: 'S12',
            quality: 'derived_monthly_mean',
        },
        mortgage_rate_pct: {
            value: 7.848333333333334,
            source: 'S13',
            quality: 'derived_monthly_mean',
        },
        mortgage_2y75_pct: {
            value: 4.805000000000001,
            source: 'S14',
            quality: 'derived_monthly_mean',
        },
        bank_avg_pct: {
            value: 5.10792349726776,
            source: 'S11',
            quality: 'derived_daily_time_weighted',
        },
        bank_end_pct: {
            value: 4.75,
            source: 'S11',
            quality: 'observed',
        },
        world_gbp_gross_pct: {
            value: null,
            source: 'S20',
            quality: 'withheld_unlicensed',
        },
        house_price_basis: 'December/December',
        mortgage_basis: 'annual average quoted revert-to rate; NOT effective stock rate',
    },
];
export const RESEARCH_WINDOWS = [
    {
        id: 'depression-1929',
        researchTitle: 'Depression and deflation',
        from: 1929,
        to: 1934,
        bankRateStartPct: 4.5,
    },
    {
        id: 'stagflation-1973',
        researchTitle: 'Oil shock and stagflation',
        from: 1973,
        to: 1978,
        bankRateStartPct: 9,
    },
    {
        id: 'tightening-1979',
        researchTitle: 'Second oil shock and high rates',
        from: 1979,
        to: 1983,
        bankRateStartPct: 12.5,
    },
    {
        id: 'october-1987',
        researchTitle: 'Black Monday and subsequent years',
        from: 1987,
        to: 1989,
        bankRateStartPct: 10.875,
    },
    {
        id: 'housing-erm-1989',
        researchTitle: 'Housing downturn, recession and ERM exit',
        from: 1989,
        to: 1995,
        bankRateStartPct: 12.875,
    },
    {
        id: 'bonds-1994',
        researchTitle: 'Bond sell-off and subsequent years',
        from: 1994,
        to: 1996,
        bankRateStartPct: 5.375,
    },
    {
        id: 'asia-ltcm-1997',
        researchTitle: 'Asian and Russian crises / LTCM: UK transmission',
        from: 1997,
        to: 1999,
        bankRateStartPct: 5.9375,
    },
    {
        id: 'dotcom-2000',
        researchTitle: 'Dot-com decline and subsequent years',
        from: 2000,
        to: 2005,
        bankRateStartPct: 5.5,
    },
    {
        id: 'gfc-2008',
        researchTitle: 'Global financial crisis',
        from: 2008,
        to: 2012,
        bankRateStartPct: 5.5,
    },
    {
        id: 'euro-2010',
        researchTitle: 'Euro-area debt stress: UK transmission',
        from: 2010,
        to: 2013,
        bankRateStartPct: 0.5,
    },
    {
        id: 'brexit-2016',
        researchTitle: 'Brexit vote and sterling repricing',
        from: 2016,
        to: 2019,
        bankRateStartPct: 0.5,
    },
    {
        id: 'pandemic-2020',
        researchTitle: 'Pandemic and reopening',
        from: 2020,
        to: 2021,
        bankRateStartPct: 0.75,
    },
    {
        id: 'inflation-2022',
        researchTitle: 'Inflation, rate rises and gilt losses',
        from: 2022,
        to: 2024,
        bankRateStartPct: 0.25,
    },
];
export const INTERNATIONAL_RECORDS = [
    {
        country: 'JPN',
        year: 1990,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 1991,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 1992,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 1993,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 1994,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 1995,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 1996,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 1997,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 1998,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 1999,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 2000,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 2001,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 2002,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'JPN',
        year: 2003,
        source: 'S01',
        currency: 'JPY',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'USA',
        year: 1929,
        source: 'S01',
        currency: 'USD',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'USA',
        year: 1930,
        source: 'S01',
        currency: 'USD',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'USA',
        year: 1931,
        source: 'S01',
        currency: 'USD',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'USA',
        year: 1932,
        source: 'S01',
        currency: 'USD',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'USA',
        year: 1933,
        source: 'S01',
        currency: 'USD',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
    {
        country: 'USA',
        year: 1934,
        source: 'S01',
        currency: 'USD',
        withheld: true,
        equity_tr_pct: null,
        government_bond_tr_pct: null,
        bill_return_pct: null,
        house_price_pct: null,
        cpi_pct: null,
        long_rate_pct: null,
        short_rate_pct: null,
    },
];
/**
 * Monthly Bank of England quotes (annualised percent), keyed by month-end date.
 * IUMBV34: two-year fixed mortgage, 75% LTV. IUMTLMV: revert-to (variable)
 * mortgage rate. IUMB6VJ: instant-access household deposits.
 */
export const MONTHLY_RATE_QUOTES = {
    IUMBV34: {
        '2010-01-31': 3.97,
        '2010-02-28': 3.88,
        '2010-03-31': 3.92,
        '2010-04-30': 3.82,
        '2010-05-31': 3.78,
        '2010-06-30': 3.67,
        '2010-07-31': 3.77,
        '2010-08-31': 3.74,
        '2010-09-30': 3.8,
        '2010-10-31': 3.68,
        '2010-11-30': 3.53,
        '2010-12-31': 3.5,
        '2011-01-31': 3.7,
        '2011-02-28': 3.7,
        '2011-03-31': 3.68,
        '2011-04-30': 3.66,
        '2011-05-31': 3.51,
        '2011-06-30': 3.36,
        '2011-07-31': 3.14,
        '2011-08-31': 3,
        '2011-09-30': 2.92,
        '2011-10-31': 3.04,
        '2011-11-30': 3.14,
        '2011-12-31': 3.22,
        '2012-01-31': 3.27,
        '2012-02-29': 3.37,
        '2012-03-31': 3.44,
        '2012-04-30': 3.66,
        '2012-05-31': 3.68,
        '2012-06-30': 3.74,
        '2012-07-31': 3.67,
        '2012-08-31': 3.69,
        '2012-09-30': 3.67,
        '2012-10-31': 3.49,
        '2012-11-30': 3.43,
        '2012-12-31': 3.35,
        '2013-01-31': 3.11,
        '2013-02-28': 2.92,
        '2013-03-31': 2.9,
        '2013-04-30': 2.87,
        '2013-05-31': 2.69,
        '2013-06-30': 2.63,
        '2013-07-31': 2.62,
        '2013-08-31': 2.58,
        '2013-09-30': 2.54,
        '2013-10-31': 2.48,
        '2013-11-30': 2.44,
        '2013-12-31': 2.4,
        '2014-01-31': 2.37,
        '2014-02-28': 2.38,
        '2014-03-31': 2.37,
        '2014-04-30': 2.54,
        '2014-05-31': 2.56,
        '2014-06-30': 2.6,
        '2014-07-31': 2.54,
        '2014-08-31': 2.54,
        '2014-09-30': 2.46,
        '2014-10-31': 2.21,
        '2014-11-30': 2.17,
        '2014-12-31': 2.08,
        '2015-01-31': 2.01,
        '2015-02-28': 1.96,
        '2015-03-31': 1.99,
        '2015-04-30': 1.95,
        '2015-05-31': 1.9,
        '2015-06-30': 1.83,
        '2015-07-31': 1.87,
        '2015-08-31': 1.95,
        '2015-09-30': 1.91,
        '2015-10-31': 1.87,
        '2015-11-30': 1.92,
        '2015-12-31': 1.9,
        '2016-01-31': 1.93,
        '2016-02-29': 1.95,
        '2016-03-31': 1.9,
        '2016-04-30': 1.84,
        '2016-05-31': 1.91,
        '2016-06-30': 1.75,
        '2016-07-31': 1.72,
        '2016-08-31': 1.69,
        '2016-09-30': 1.59,
        '2016-10-31': 1.52,
        '2016-11-30': 1.43,
        '2016-12-31': 1.45,
        '2017-01-31': 1.45,
        '2017-02-28': 1.42,
        '2017-03-31': 1.37,
        '2017-04-30': 1.35,
        '2017-05-31': 1.49,
        '2017-06-30': 1.48,
        '2017-07-31': 1.41,
        '2017-08-31': 1.43,
        '2017-09-30': 1.4,
        '2017-10-31': 1.55,
        '2017-11-30': 1.61,
        '2017-12-31': 1.57,
        '2018-01-31': 1.54,
        '2018-02-28': 1.49,
        '2018-03-31': 1.53,
        '2018-04-30': 1.72,
        '2018-05-31': 1.74,
        '2018-06-30': 1.74,
        '2018-07-31': 1.75,
        '2018-08-31': 1.75,
        '2018-09-30': 1.71,
        '2018-10-31': 1.8,
        '2018-11-30': 1.75,
        '2018-12-31': 1.73,
        '2019-01-31': 1.72,
        '2019-02-28': 1.7,
        '2019-03-31': 1.7,
        '2019-04-30': 1.66,
        '2019-05-31': 1.65,
        '2019-06-30': 1.64,
        '2019-07-31': 1.61,
        '2019-08-31': 1.59,
        '2019-09-30': 1.55,
        '2019-10-31': 1.47,
        '2019-11-30': 1.41,
        '2019-12-31': 1.42,
        '2020-01-31': 1.41,
        '2020-02-29': 1.4,
        '2020-03-31': 1.4,
        '2020-04-30': 1.38,
        '2020-05-31': 1.42,
        '2020-06-30': 1.41,
        '2020-07-31': 1.45,
        '2020-08-31': 1.6,
        '2020-09-30': 1.75,
        '2020-10-31': 1.94,
        '2020-11-30': 1.92,
        '2020-12-31': 1.86,
        '2021-01-31': 1.75,
        '2021-02-28': 1.61,
        '2021-03-31': 1.56,
        '2021-04-30': 1.49,
        '2021-05-31': 1.47,
        '2021-06-30': 1.39,
        '2021-07-31': 1.29,
        '2021-08-31': 1.23,
        '2021-09-30': 1.2,
        '2021-10-31': 1.29,
        '2021-11-30': 1.53,
        '2021-12-31': 1.57,
        '2022-01-31': 1.64,
        '2022-02-28': 1.78,
        '2022-03-31': 2.14,
        '2022-04-30': 2.35,
        '2022-05-31': 2.63,
        '2022-06-30': 2.87,
        '2022-07-31': 3.48,
        '2022-08-31': 3.6,
        '2022-09-30': 4.17,
        '2022-10-31': 5.99,
        '2022-11-30': 5.98,
        '2022-12-31': 5.43,
        '2023-01-31': 5.14,
        '2023-02-28': 4.79,
        '2023-03-31': 4.74,
        '2023-04-30': 4.6,
        '2023-05-31': 4.72,
        '2023-06-30': 5.49,
        '2023-07-31': 6.22,
        '2023-08-31': 6.18,
        '2023-09-30': 5.91,
        '2023-10-31': 5.6,
        '2023-11-30': 5.28,
        '2023-12-31': 5.03,
        '2024-01-31': 4.71,
        '2024-02-29': 4.76,
        '2024-03-31': 4.96,
        '2024-04-30': 4.98,
        '2024-05-31': 5.19,
        '2024-06-30': 5.16,
        '2024-07-31': 4.99,
        '2024-08-31': 4.8,
        '2024-09-30': 4.58,
        '2024-10-31': 4.4,
        '2024-11-30': 4.53,
        '2024-12-31': 4.6,
        '2025-01-31': 4.63,
        '2025-02-28': 4.65,
        '2025-03-31': 4.54,
        '2025-04-30': 4.42,
    },
    IUMTLMV: {
        '2010-01-31': 4.08,
        '2010-02-28': 4.05,
        '2010-03-31': 4.04,
        '2010-04-30': 3.99,
        '2010-05-31': 3.94,
        '2010-06-30': 3.92,
        '2010-07-31': 3.92,
        '2010-08-31': 3.94,
        '2010-09-30': 3.93,
        '2010-10-31': 3.91,
        '2010-11-30': 3.91,
        '2010-12-31': 3.91,
        '2011-01-31': 4.04,
        '2011-02-28': 4.07,
        '2011-03-31': 4.07,
        '2011-04-30': 4,
        '2011-05-31': 4,
        '2011-06-30': 4.05,
        '2011-07-31': 4.1,
        '2011-08-31': 4.11,
        '2011-09-30': 4.12,
        '2011-10-31': 4.14,
        '2011-11-30': 4.13,
        '2011-12-31': 4.12,
        '2012-01-31': 4.18,
        '2012-02-29': 4.14,
        '2012-03-31': 4.1,
        '2012-04-30': 4.1,
        '2012-05-31': 4.16,
        '2012-06-30': 4.22,
        '2012-07-31': 4.24,
        '2012-08-31': 4.27,
        '2012-09-30': 4.29,
        '2012-10-31': 4.32,
        '2012-11-30': 4.32,
        '2012-12-31': 4.35,
        '2013-01-31': 4.38,
        '2013-02-28': 4.38,
        '2013-03-31': 4.34,
        '2013-04-30': 4.35,
        '2013-05-31': 4.38,
        '2013-06-30': 4.38,
        '2013-07-31': 4.37,
        '2013-08-31': 4.36,
        '2013-09-30': 4.35,
        '2013-10-31': 4.37,
        '2013-11-30': 4.41,
        '2013-12-31': 4.39,
        '2014-01-31': 4.41,
        '2014-02-28': 4.43,
        '2014-03-31': 4.43,
        '2014-04-30': 4.43,
        '2014-05-31': 4.42,
        '2014-06-30': 4.36,
        '2014-07-31': 4.45,
        '2014-08-31': 4.45,
        '2014-09-30': 4.52,
        '2014-10-31': 4.53,
        '2014-11-30': 4.49,
        '2014-12-31': 4.48,
        '2015-01-31': 4.56,
        '2015-02-28': 4.51,
        '2015-03-31': 4.51,
        '2015-04-30': 4.53,
        '2015-05-31': 4.55,
        '2015-06-30': 4.49,
        '2015-07-31': 4.5,
        '2015-08-31': 4.48,
        '2015-09-30': 4.5,
        '2015-10-31': 4.54,
        '2015-11-30': 4.49,
        '2015-12-31': 4.49,
        '2016-01-31': 4.56,
        '2016-02-29': 4.58,
        '2016-03-31': 4.57,
        '2016-04-30': 4.64,
        '2016-05-31': 4.56,
        '2016-06-30': 4.52,
        '2016-07-31': 4.55,
        '2016-08-31': 4.3,
        '2016-09-30': 4.24,
        '2016-10-31': 4.24,
        '2016-11-30': 4.28,
        '2016-12-31': 4.23,
        '2017-01-31': 4.49,
        '2017-02-28': 4.37,
        '2017-03-31': 4.28,
        '2017-04-30': 4.54,
        '2017-05-31': 4.23,
        '2017-06-30': 4.28,
        '2017-07-31': 4.51,
        '2017-08-31': 4.32,
        '2017-09-30': 4.31,
        '2017-10-31': 4.31,
        '2017-11-30': 4.34,
        '2017-12-31': 4.54,
        '2018-01-31': 4.21,
        '2018-02-28': 4.23,
        '2018-03-31': 4.14,
        '2018-04-30': 4.17,
        '2018-05-31': 4.16,
        '2018-06-30': 4.06,
        '2018-07-31': 4.1,
        '2018-08-31': 4.35,
        '2018-09-30': 4.39,
        '2018-10-31': 4.45,
        '2018-11-30': 4.41,
        '2018-12-31': 4.4,
        '2019-01-31': 4.48,
        '2019-02-28': 4.31,
        '2019-03-31': 4.31,
        '2019-04-30': 4.31,
        '2019-05-31': 4.29,
        '2019-06-30': 4.29,
        '2019-07-31': 4.29,
        '2019-08-31': 4.29,
        '2019-09-30': 4.29,
        '2019-10-31': 4.27,
        '2019-11-30': 4.27,
        '2019-12-31': 4.27,
        '2020-01-31': 4.27,
        '2020-02-29': 4.26,
        '2020-03-31': 4.1,
        '2020-04-30': 3.66,
        '2020-05-31': 3.65,
        '2020-06-30': 3.65,
        '2020-07-31': 3.66,
        '2020-08-31': 3.65,
        '2020-09-30': 3.65,
        '2020-10-31': 3.64,
        '2020-11-30': 3.62,
        '2020-12-31': 3.62,
        '2021-01-31': 3.62,
        '2021-02-28': 3.62,
        '2021-03-31': 3.62,
        '2021-04-30': 3.61,
        '2021-05-31': 3.61,
        '2021-06-30': 3.61,
        '2021-07-31': 3.61,
        '2021-08-31': 3.61,
        '2021-09-30': 3.61,
        '2021-10-31': 3.6,
        '2021-11-30': 3.59,
        '2021-12-31': 3.61,
        '2022-01-31': 3.67,
        '2022-02-28': 3.84,
        '2022-03-31': 3.99,
        '2022-04-30': 4.11,
        '2022-05-31': 4.26,
        '2022-06-30': 4.39,
        '2022-07-31': 4.55,
        '2022-08-31': 4.88,
        '2022-09-30': 5.1,
        '2022-10-31': 5.42,
        '2022-11-30': 5.87,
        '2022-12-31': 6.42,
        '2023-01-31': 6.61,
        '2023-02-28': 6.97,
        '2023-03-31': 7.16,
        '2023-04-30': 7.3,
        '2023-05-31': 7.38,
        '2023-06-30': 7.47,
        '2023-07-31': 7.64,
        '2023-08-31': 7.91,
        '2023-09-30': 7.98,
        '2023-10-31': 8.02,
        '2023-11-30': 8,
        '2023-12-31': 7.92,
        '2024-01-31': 7.94,
        '2024-02-29': 7.94,
        '2024-03-31': 7.93,
        '2024-04-30': 8,
        '2024-05-31': 8,
        '2024-06-30': 8.03,
        '2024-07-31': 8.07,
        '2024-08-31': 7.86,
        '2024-09-30': 7.7,
        '2024-10-31': 7.68,
        '2024-11-30': 7.56,
        '2024-12-31': 7.47,
        '2025-01-31': 7.48,
        '2025-02-28': 7.35,
        '2025-03-31': 7.24,
        '2025-04-30': 7.19,
    },
    IUMB6VJ: {
        '2019-04-30': 0.45,
        '2019-05-31': 0.45,
        '2019-06-30': 0.44,
        '2019-07-31': 0.44,
        '2019-08-31': 0.43,
        '2019-09-30': 0.43,
        '2019-10-31': 0.43,
        '2019-11-30': 0.43,
        '2019-12-31': 0.41,
        '2020-01-31': 0.41,
        '2020-02-29': 0.41,
        '2020-03-31': 0.39,
        '2020-04-30': 0.28,
        '2020-05-31': 0.23,
        '2020-06-30': 0.16,
        '2020-07-31': 0.09,
        '2020-08-31': 0.07,
        '2020-09-30': 0.07,
        '2020-10-31': 0.08,
        '2020-11-30': 0.07,
        '2020-12-31': 0.06,
        '2021-01-31': 0.06,
        '2021-02-28': 0.06,
        '2021-03-31': 0.07,
        '2021-04-30': 0.06,
        '2021-05-31': 0.06,
        '2021-06-30': 0.07,
        '2021-07-31': 0.08,
        '2021-08-31': 0.09,
        '2021-09-30': 0.11,
        '2021-10-31': 0.11,
        '2021-11-30': 0.11,
        '2021-12-31': 0.11,
        '2022-01-31': 0.11,
        '2022-02-28': 0.12,
        '2022-03-31': 0.15,
        '2022-04-30': 0.22,
        '2022-05-31': 0.26,
        '2022-06-30': 0.31,
        '2022-07-31': 0.42,
        '2022-08-31': 0.47,
        '2022-09-30': 0.64,
        '2022-10-31': 0.92,
        '2022-11-30': 0.99,
        '2022-12-31': 1.2,
        '2023-01-31': 1.24,
        '2023-02-28': 1.44,
        '2023-03-31': 1.53,
        '2023-04-30': 1.63,
        '2023-05-31': 1.74,
        '2023-06-30': 1.82,
        '2023-07-31': 2.23,
        '2023-08-31': 2.56,
        '2023-09-30': 2.74,
        '2023-10-31': 2.77,
        '2023-11-30': 2.8,
        '2023-12-31': 2.81,
        '2024-01-31': 2.82,
        '2024-02-29': 2.81,
        '2024-03-31': 2.8,
        '2024-04-30': 2.77,
        '2024-05-31': 2.76,
        '2024-06-30': 2.78,
        '2024-07-31': 2.79,
        '2024-08-31': 2.73,
        '2024-09-30': 2.66,
        '2024-10-31': 2.65,
        '2024-11-30': 2.67,
        '2024-12-31': 2.59,
        '2025-01-31': 2.62,
        '2025-02-28': 2.57,
        '2025-03-31': 2.45,
        '2025-04-30': 2.46,
        '2011-01-31': 1.29,
        '2011-02-28': 1.31,
        '2011-03-31': 1.33,
        '2011-04-30': 1.44,
        '2011-05-31': 1.45,
        '2011-06-30': 1.46,
        '2011-07-31': 1.42,
        '2011-08-31': 1.47,
        '2011-09-30': 1.5,
        '2011-10-31': 1.51,
        '2011-11-30': 1.52,
        '2011-12-31': 1.52,
        '2012-01-31': 1.54,
        '2012-02-29': 1.55,
        '2012-03-31': 1.54,
        '2012-04-30': 1.54,
        '2012-05-31': 1.53,
        '2012-06-30': 1.55,
        '2012-07-31': 1.55,
        '2012-08-31': 1.53,
        '2012-09-30': 1.53,
        '2012-10-31': 1.42,
        '2012-11-30': 1.07,
        '2012-12-31': 1.05,
        '2013-01-31': 1.05,
        '2013-02-28': 1.03,
        '2013-03-31': 0.98,
        '2013-04-30': 0.98,
        '2013-05-31': 0.83,
        '2013-06-30': 0.83,
        '2013-07-31': 0.76,
        '2013-08-31': 0.75,
        '2013-09-30': 0.75,
        '2013-10-31': 0.75,
        '2013-11-30': 0.75,
        '2013-12-31': 0.81,
        '2014-01-31': 0.76,
        '2014-02-28': 0.73,
        '2014-03-31': 0.73,
        '2014-04-30': 0.73,
        '2014-05-31': 0.73,
        '2014-06-30': 0.72,
        '2014-07-31': 0.62,
        '2014-08-31': 0.62,
        '2014-09-30': 0.62,
        '2014-10-31': 0.63,
        '2014-11-30': 0.57,
        '2014-12-31': 0.57,
        '2015-01-31': 0.55,
        '2015-02-28': 0.55,
        '2015-03-31': 0.55,
        '2015-04-30': 0.56,
        '2015-05-31': 0.56,
        '2015-06-30': 0.54,
        '2015-07-31': 0.54,
        '2015-08-31': 0.55,
        '2015-09-30': 0.54,
        '2015-10-31': 0.54,
        '2015-11-30': 0.54,
        '2015-12-31': 0.48,
        '2016-01-31': 0.47,
        '2016-02-29': 0.46,
        '2016-03-31': 0.46,
        '2016-04-30': 0.44,
        '2016-05-31': 0.4,
        '2016-06-30': 0.4,
        '2016-07-31': 0.34,
        '2016-08-31': 0.28,
        '2016-09-30': 0.28,
        '2016-10-31': 0.26,
        '2016-11-30': 0.25,
        '2016-12-31': 0.15,
        '2017-01-31': 0.15,
        '2017-02-28': 0.15,
        '2017-03-31': 0.15,
        '2017-04-30': 0.15,
        '2017-05-31': 0.15,
        '2017-06-30': 0.15,
        '2017-07-31': 0.14,
        '2017-08-31': 0.14,
        '2017-09-30': 0.14,
        '2017-10-31': 0.12,
        '2017-11-30': 0.12,
        '2017-12-31': 0.21,
        '2018-01-31': 0.2,
        '2018-02-28': 0.2,
        '2018-03-31': 0.21,
        '2018-04-30': 0.2,
        '2018-05-31': 0.2,
        '2018-06-30': 0.21,
        '2018-07-31': 0.21,
        '2018-08-31': 0.22,
        '2018-09-30': 0.27,
        '2018-10-31': 0.27,
        '2018-11-30': 0.27,
        '2018-12-31': 0.27,
        '2019-01-31': 0.27,
        '2019-02-28': 0.45,
        '2019-03-31': 0.45,
    },
};
export const HISTORICAL_SOURCE_REGISTER = {
    S01: {
        title: 'Jordà–Schularick–Taylor Macrohistory Database, Release 6',
        url: 'https://www.macrohistory.net/database/',
        note: 'UK, Japan and US country rows; nominal local-currency eq_tr, bond_tr, bill_rate, housing_capgain and CPI. Research composites, not a single unchanged modern index. Data stop at 2020. CC BY-NC-SA 4.0; commercial product use is not cleared by this document.',
        retrievedAt: '2026-09-17',
    },
    S02: {
        title: 'Bank of England: A millennium of macroeconomic data, v3.1',
        url: 'https://www.bankofengland.co.uk/statistics/research-datasets',
        note: 'Downloaded workbook through 2016. A1: AP inflation, AN earnings, C GDP growth, AB unemployment, BA USD/GBP, AZ share prices. A31: B/C policy end/average, L effective mortgage, O deposit, S gilt yield, U corporate yield, V spread. Historical splices retain the workbook definitions.',
        retrievedAt: '2026-09-17',
    },
    S03: {
        title: 'JST return-series documentation and R6 supplement',
        url: 'https://www.macrohistory.net/app/download/9834516469/RORE_documentation.pdf?t=1614633099',
        note: 'UK historical equities change coverage; government bond maturity is not constant. R6 supplement: https://www.macrohistory.net/app/download/9918957869/JST_RORE_Documentation_R6.pdf?t=1658254098 . Do not rename JST returns as FTSE benchmark observations.',
        retrievedAt: '2026-09-17',
    },
    S04: {
        title: 'FTSE All-Share factsheet, 30 September 2016',
        url: 'https://www.investmentofficer.nl/sites/default/files/FTSE_All_Share_Index.pdf',
        note: 'Publisher-authored factsheet on a third-party mirror; page 1, calendar-year GBP total returns. Covers 2006–2015; this document uses 2008–2013.',
        retrievedAt: '2026-09-17',
    },
    S05: {
        title: 'FTSE All-Share factsheet, May 2026',
        url: 'https://research.ftserussell.com/Analytics/FactSheets/temp/2315980a-dca5-48c3-937b-ad6d05aecd5b.pdf',
        note: 'Page 1 calendar-year GBP total returns; 2016–2024 used. Publisher temporary URL; retain an authorised archival copy for production review.',
        retrievedAt: '2026-09-17',
    },
    S06: {
        title: 'BlackRock iShares UK Gilts All Stocks, Class L KIID, 18 June 2018',
        url: 'https://www.pfgl.co.uk/wp-content/uploads/2019/01/EFP1-iShares-UK-Gilts-All-Stocks-Index-Fund.pdf',
        note: 'Page 2, Benchmark row, not Fund row: 2008 11.7; 2009 -1.4; 2010 6.3; 2011 14.6; 2012 2.0; 2013 -4.6 percent. Publisher-authored document on a third-party mirror. Retain valuation-method footnote.',
        retrievedAt: '2026-09-17',
    },
    S07: {
        title: 'BlackRock iShares UK Gilts All Stocks, Class H, August 2026',
        url: 'https://www.blackrock.com/uk/literature/fact-sheet/ishares-uk-gilts-all-stocks-index-fund-uk-class-h-accu-gbp-factsheet-gb00bpfjdd09-gb-en-individual.pdf',
        note: 'Page 2, Target 1 calendar-year row. FTSE Actuaries UK Conventional Gilts All Stocks (Midday), GBP. Benchmark valuation changed on 29 April 2016; earlier simulated history is described in the footnote.',
        retrievedAt: '2026-09-17',
    },
    S08: {
        title: 'HM Land Registry / ONS: UK House Price Index',
        url: 'https://landregistry.data.gov.uk/data/ukhpi/region/united-kingdom/month/2022-12.json',
        note: 'Use primaryTopic.percentageAnnualChange in each December JSON, substituting YYYY-12. UK, all property types, price-only. Raw snapshots retained for every year used.',
        retrievedAt: '2026-09-17',
    },
    S09: {
        title: 'ONS D7G7: CPI annual rate',
        url: 'https://www.ons.gov.uk/economy/inflationandpriceindices/timeseries/d7g7/mm23',
        note: 'Annual rows for average-year inflation; monthly December rows separately. ONS D7BT index is used for monthly price-level ratios. Downloads dated 16 September 2026.',
        retrievedAt: '2026-09-17',
    },
    S10: {
        title: 'ONS CZBH: RPI annual rate',
        url: 'https://www.ons.gov.uk/economy/inflationandpriceindices/timeseries/czbh/mm23',
        note: 'Annual rows, not December rates. CHAW supplies the index from 1987. No modern RPI series for 1929–1934 is invented.',
        retrievedAt: '2026-09-17',
    },
    S11: {
        title: 'Bank of England: official Bank Rate history',
        url: 'https://www.bankofengland.co.uk/boeapps/database/Bank-Rate.asp',
        note: 'Effective-date change table. End-year level and daily time-weighted annual mean calculated for 2017–2024; pre-2017 figures use S02. Earlier policy instruments have different names.',
        retrievedAt: '2026-09-17',
    },
    S12: {
        title: 'Bank of England IUMB6VJ: instant-access household deposit quotes',
        url: 'https://www.bankofengland.co.uk/boeapps/database/fromshowcolumns.asp?CSVF=TT&DAT=RNG&FD=1&FM=Jan&FNY=Y&FY=2010&Filter=N&FromSeries=1&SeriesCodes=IUMB6VJ&TD=11&TM=May&TY=2025&ToSeries=50&Travel=NIxAZxSUx&UsingCodes=Y&VPD=Y&html.x=66&html.y=26&title=IUMB6VJ',
        note: 'Arithmetic mean of 12 published monthly quotes, 2017–2024. This is a savings-rate proxy, not a total-return index or every household’s achieved rate. Sample/method breaks in July 2018 and February 2019.',
        retrievedAt: '2026-09-17',
    },
    S13: {
        title: 'Bank of England IUMTLMV: quoted revert-to mortgage rate',
        url: 'https://www.bankofengland.co.uk/boeapps/database/fromshowcolumns.asp?CSVF=TT&DAT=RNG&FD=1&FM=Jan&FNY=Y&FY=2010&Filter=N&FromSeries=1&SeriesCodes=IUMTLMV&TD=11&TM=May&TY=2025&ToSeries=50&Travel=NIxAZxSUx&UsingCodes=Y&VPD=Y&html.x=66&html.y=26&title=IUMTLMV',
        note: 'Annual arithmetic mean of monthly quoted rates, 2017–2024. A variable/revert-to comparator; not interchangeable with the pre-2017 effective mortgage stock rate.',
        retrievedAt: '2026-09-17',
    },
    S14: {
        title: 'Bank of England IUMBV34: two-year fixed mortgage, 75% LTV',
        url: 'https://www.bankofengland.co.uk/boeapps/database/fromshowcolumns.asp?CSVF=TT&DAT=RNG&FD=1&FM=Jan&FNY=Y&FY=2010&Filter=N&FromSeries=1&SeriesCodes=IUMBV34&TD=11&TM=May&TY=2025&ToSeries=50&Travel=NIxAZxSUx&UsingCodes=Y&VPD=Y&html.x=66&html.y=26&title=IUMBV34',
        note: 'Monthly quotes and annual means. Use the quote at the remortgage month for a new fixed deal, then hold it for the contract term; never reprice an existing fix every month.',
        retrievedAt: '2026-09-17',
    },
    S15: {
        title: 'OECD via FRED: UK ten-year government yield, IRLTLT01GBA156N',
        url: 'https://fred.stlouisfed.org/data/IRLTLT01GBA156N',
        note: 'Annual percent, not a bond holding-period return. Modern tail 2016–2024 from this series; earlier observations may use S02 as recorded per field in annual-inputs.json.',
        retrievedAt: '2026-09-17',
    },
    S16: {
        title: 'ONS KAB9: whole-economy average weekly total pay',
        url: 'https://www.ons.gov.uk/employmentandlabourmarket/peopleinwork/earningsandworkinghours/timeseries/kab9/lms',
        note: 'Annual-average level ratio less one, seasonally adjusted total pay excluding arrears. Derived from rounded published levels; not an individual employee’s pay award. BoE earnings composite used where consecutive ONS years unavailable.',
        retrievedAt: '2026-09-17',
    },
    S17: {
        title: 'ONS IHYP: real GDP annual growth',
        url: 'https://www.ons.gov.uk/economy/grossdomesticproductgdp/timeseries/ihyp/pn2',
        note: 'Calendar-year growth, chained volumes, seasonally adjusted; current vintage as retrieved. Earlier 1930s values from S02.',
        retrievedAt: '2026-09-17',
    },
    S18: {
        title: 'ONS MGSX: unemployment rate',
        url: 'https://www.ons.gov.uk/employmentandlabourmarket/peoplenotinwork/unemployment/timeseries/mgsx/lms',
        note: 'Annual, aged 16+, seasonally adjusted; earlier estimates from S02. Context only: not a client’s probability of unemployment.',
        retrievedAt: '2026-09-17',
    },
    S19: {
        title: 'Federal Reserve via FRED: AEXUSUK',
        url: 'https://fred.stlouisfed.org/data/AEXUSUK',
        note: 'Annual average USD per GBP. Diagnostic context only: cannot convert end-to-end investment returns using average-year exchange rates. Earlier 1930s rates from S02.',
        retrievedAt: '2026-09-17',
    },
    S20: {
        title: 'MSCI World (GBP), gross returns, 31 December 2024 factsheet',
        url: 'https://www.msci.com/downloads/web/msci-com/indexes/index-category/pimfa-private-investor-index-series/msci-world-index-gbp-gross.pdf',
        note: 'Annual GBP gross returns for World, ACWI and Emerging Markets, 2011–2024. GBP already includes currency translation. Production analytics and redistribution permissions require separate clearance.',
        retrievedAt: '2026-09-17',
    },
    S21: {
        title: 'Bank of England: gilt-market intervention case study',
        url: 'https://www.bankofengland.co.uk/quarterly-bulletin/2023/2023/financial-stability-buy-sell-tools-a-gilt-market-case-study',
        note: '2022 LDI event: 30-year yields rose 130 basis points across three trading days by 28 September. This is a yield change, not an all-stocks gilt return.',
        retrievedAt: '2026-09-17',
    },
    S22: {
        title: 'Federal Reserve History: 1987 stock-market crash',
        url: 'https://www.federalreservehistory.org/essays/stock-market-crash-of-1987',
        note: '19 October 1987 event chronology. US Dow price fall is not UK calendar-year total return.',
        retrievedAt: '2026-09-17',
    },
    S23: {
        title: 'Federal Reserve History: Asian financial crisis',
        url: 'https://www.federalreservehistory.org/essays/asian-financial-crisis',
        note: 'Regional crisis and international transmission; the UK annual panel is not a Thai, Russian or emerging-market portfolio replay.',
        retrievedAt: '2026-09-17',
    },
    S24: {
        title: 'Bank of Japan: overcoming deflation, 2019',
        url: 'https://www.boj.or.jp/en/about/press/koen_2019/ko190723a.htm',
        note: 'Context for the Japanese post-bubble episode and deflation. Japan data panel uses S01.',
        retrievedAt: '2026-09-17',
    },
    S25: {
        title: 'Bank of England: history',
        url: 'https://www.bankofengland.co.uk/about/history',
        note: 'UK ERM and policy-regime chronology; supporting background, not a numeric input source.',
        retrievedAt: '2026-09-17',
    },
};
//# sourceMappingURL=historical-scenario-data.js.map